import {AxiosError} from 'axios'

import {API} from '../../../networking/http'
import {QueryOptions, UseQueryOptions} from '../../helpers/types'
import {SubscriptionBooking} from '../types'

export type GetSubscriptionBookingsByMemberParams = {
  venueId?: string
  memberId?: string
}
export type GetSubscriptionBookingsByMemberQueryParams = undefined

export type GetSubscriptionBookingsByMemberReturnType = SubscriptionBooking[]

type Par = QueryOptions<
  GetSubscriptionBookingsByMemberParams,
  GetSubscriptionBookingsByMemberQueryParams,
  GetSubscriptionBookingsByMemberReturnType
>

type QueOp = UseQueryOptions<GetSubscriptionBookingsByMemberReturnType, AxiosError, GetSubscriptionBookingsByMemberReturnType, [string, GetSubscriptionBookingsByMemberParams?]>

export const makeGetSubscriptionBookingsByMemberEndpoint = (venueId?: string, memberId?: string) => `bookings/${venueId}/memberSubscriptions/${memberId}`

export const getSubscriptionBookingsByMemberQuery = ({query, params}: Par): QueOp => ({
  queryKey: ['getSubscriptionBookingsByMemberQuery', query],
  cacheTime: 1000 * 300,
  queryFn: ({queryKey: [_, config]}) =>
    API.post<GetSubscriptionBookingsByMemberQueryParams, SubscriptionBooking[]>(makeGetSubscriptionBookingsByMemberEndpoint(
      params?.venueId,
      params?.memberId
    ), {
      params: config,
      elementsPerPage: 1000,
    }).then((res) => res.data),
})
